import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Collapse,
} from "reactstrap";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import { TableHeader, Pagination, Search } from "../../DataTable";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import Switch from "@material-ui/core/Switch";
import moment from "moment";

function ReporteCompras() {
  const { user } = useContext(AuthContext);
  // Si no existe la variable (p.ej. Netlify sin actualizar) se arma desde articulos
  const URL_REPORTE_COMPRAS =
    process.env.REACT_APP_URL_REPORTE_COMPRAS ||
    (process.env.REACT_APP_URL_ARTICULOS || "").replace(
      /articulos$/,
      "reporteCompras"
    );
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 365);

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(
    moment(inicio).format("YYYY-MM-DD")
  );
  const [selectedFechaFin, setSelectedFechaFin] = useState(
    moment(hoy).format("YYYY-MM-DD")
  );

  const [lineas, setLineas] = useState([]);
  const [selectedLineaFiltro, setSelectedLineaFiltro] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [selectedEmpresaFiltro, setSelectedEmpresaFiltro] = useState([]);
  // Los switches ocupan mucho: el panel arranca cerrado
  const [verFiltros, setVerFiltros] = useState(false);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [cargando, setCargando] = useState(true);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  const Toast = Swal.mixin({
    toast: true,
    position: "center",
    showConfirmButton: false,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });
  if (cargando) {
    Toast.fire({
      html: `<i class="fas fa-hourglass-half custom-spin fa-2x" style="margin-right: 16px;"></i>`,
      title: "Danos unos segundos....",
      customClass: {
        icon: "animated-icon",
      },
    });
  }

  useEffect(() => {
    setCargando(true);
    axios
      .get(`${URL_REPORTE_COMPRAS}/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allCompras = response.data;
        setComments(allCompras);

        // El catalogo del filtro sale de lo comprado en el periodo
        let unicosLinea = allCompras.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.idLinea === value.idLinea)
        );
        setLineas(unicosLinea);

        let unicosEmpresa = allCompras.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.idEmpresa === value.idEmpresa)
        );
        setEmpresas(unicosEmpresa);

        setCargando(false);
        Toast.close();
      })
      .catch((err) => {
        console.log(err);
        setCargando(false);
        Toast.close();
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "No se pudo cargar el reporte de compras",
        });
      });
  }, [selectedFechaInicio, selectedFechaFin]);

  const dinero = (n) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 2,
    }).format(n || 0);
  const numero = (n) => new Intl.NumberFormat("en-US").format(n || 0);

  // Mismo criterio de busqueda / filtro para tabla, PDF, eMail y Excel
  const coincideBusqueda = (c, texto) => {
    if (!texto) return true;
    const t = texto.toLowerCase();
    return (
      String(c.SKU || "").toLowerCase().includes(t) ||
      String(c.codigo || "").toLowerCase().includes(t) ||
      String(c.nombre || "").toLowerCase().includes(t) ||
      String(c.linea || "").toLowerCase().includes(t) ||
      String(c.empresa || "").toLowerCase().includes(t) ||
      String(c.area || "").toLowerCase().includes(t) ||
      String(c.proveedor || "").toLowerCase().includes(t) ||
      String(c.compra || "").includes(texto) ||
      String(c.fecha || "").includes(texto) ||
      String(c.cantidad || "").includes(texto) ||
      String(c.costoMX || "").includes(texto)
    );
  };

  const datosFiltrados = useMemo(() => {
    let temp = comments.filter((c) => coincideBusqueda(c, search));
    if (selectedLineaFiltro.length) {
      temp = temp.filter((c) => selectedLineaFiltro.includes(c.idLinea));
    }
    if (selectedEmpresaFiltro.length) {
      temp = temp.filter((c) => selectedEmpresaFiltro.includes(c.idEmpresa));
    }
    return temp;
  }, [comments, search, selectedLineaFiltro, selectedEmpresaFiltro]);

  const totales = useMemo(() => {
    return datosFiltrados.reduce(
      (t, c) => ({
        cantidad: t.cantidad + parseFloat(c.cantidad || 0),
        total: t.total + parseFloat(c.total || 0),
      }),
      { cantidad: 0, total: 0 }
    );
  }, [datosFiltrados]);

  function creaPDF() {
    const data = datosFiltrados.map((a) => [
      a.fecha,
      a.compra,
      a.SKU,
      a.nombre,
      a.linea,
      a.empresa,
      a.area,
      numero(a.cantidad),
      dinero(a.costoMX),
      dinero(a.total),
    ]);
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "/Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "/logoInstitucion.png";
    doc.addImage(img2, "png", 125, 10, 30, 30);
    doc.text(`Reporte de Compras`, 20, 35);
    doc.setFontSize(10);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 42);
    doc.autoTable({
      head: [
        [
          "Fecha",
          "Compra",
          "SKU",
          "Nombre",
          "Linea",
          "Empresa",
          "Almacen",
          "Cantidad",
          "Costo MX",
          "Total",
        ],
      ],
      body: data,
      startY: 45,
      styles: { fontSize: 8 },
      footStyles: {
        fontSize: 10,
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
      },
      foot: [
        [
          "",
          "",
          "",
          "",
          "",
          "",
          "Totales",
          numero(totales.cantidad),
          "",
          dinero(totales.total),
        ],
      ],
      showFoot: "lastPage",
    });
    return doc;
  }

  function PDFTabla() {
    creaPDF().save(
      `ReporteCompras_${selectedFechaInicio}_${selectedFechaFin}.pdf`
    );
  }

  function excel() {
    const dataExcel = datosFiltrados.map((a) => ({
      Fecha: a.fecha,
      Compra: a.compra,
      SKU: a.SKU,
      Codigo: a.codigo,
      Nombre: a.nombre,
      Linea: a.linea,
      Empresa: a.empresa,
      Proveedor: a.proveedor,
      Almacen: a.area,
      Cantidad: a.cantidad,
      CostoMX: a.costoMX,
      Total: a.total,
    }));

    const columnas = [
      "Fecha",
      "Compra",
      "SKU",
      "Codigo",
      "Nombre",
      "Linea",
      "Empresa",
      "Proveedor",
      "Almacen",
      "Cantidad",
      "CostoMX",
      "Total",
    ];

    var option = {};
    option.fileName = `ReporteCompras_${selectedFechaInicio}_${selectedFechaFin}`;
    option.datas = [
      {
        sheetData: dataExcel,
        sheetName: "ReporteCompras",
        sheetFilter: columnas,
        sheetHeader: columnas,
      },
    ];
    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const doc = creaPDF();
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Reporte de Compras",
          email: mailTo,
          fileName: "ReporteCompras.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el reporte de compras del ${selectedFechaInicio} al ${selectedFechaFin}.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "Fecha", field: "fecha", sortable: true },
    { name: "Compra", field: "compra", sortable: true },
    { name: "SKU", field: "SKU", sortable: true },
    { name: "Nombre", field: "nombre", sortable: true },
    { name: "Linea", field: "linea", sortable: true },
    { name: "Empresa", field: "empresa", sortable: true },
    { name: "Almacen", field: "area", sortable: true },
    { name: "Cantidad", field: "cantidad", sortable: true },
    { name: "Costo MX", field: "costoMX", sortable: true },
    { name: "Total", field: "total", sortable: true },
  ];

  const commentsData = useMemo(() => {
    let computedComments = datosFiltrados;

    setTotalItems(computedComments.length);

    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      const numericos = ["cantidad", "costoMX", "total", "compra"];
      computedComments = [...computedComments].sort((a, b) =>
        numericos.includes(sorting.field)
          ? reversed * (parseFloat(a[sorting.field] || 0) - parseFloat(b[sorting.field] || 0))
          : reversed *
            String(a[sorting.field] ?? "").localeCompare(
              String(b[sorting.field] ?? "")
            )
      );
    }

    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [datosFiltrados, currentPage, sorting]);

  const filtrosActivos =
    selectedLineaFiltro.length + selectedEmpresaFiltro.length;

  const handleCheckboxChangeLinea = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setSelectedLineaFiltro([...selectedLineaFiltro, value]);
    } else {
      setSelectedLineaFiltro(selectedLineaFiltro.filter((i) => i !== value));
    }
    setCurrentPage(1);
  };

  const handleCheckboxChangeEmpresa = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setSelectedEmpresaFiltro([...selectedEmpresaFiltro, value]);
    } else {
      setSelectedEmpresaFiltro(selectedEmpresaFiltro.filter((i) => i !== value));
    }
    setCurrentPage(1);
  };

  function limpiarSearch() {
    setSearch("");
    setSelectedLineaFiltro([]);
    setSelectedEmpresaFiltro([]);
    setCurrentPage(1);
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.inventarios_costosAdmin ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/MenuCompras"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i className="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i className="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i className="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Reporte de Compras</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>

          <h3 align="center">Reporte de Compras</h3>

          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                  setCurrentPage(1);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                  setCurrentPage(1);
                }}
              />
            </Col>
          </Row>

          <div className="row">
            <div className="col-md-2">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>

            <div className="col-md-6">
              <Button
                size="sm"
                className="btn"
                color="secondary"
                onClick={() => setVerFiltros(!verFiltros)}
              >
                {verFiltros ? "Ocultar filtros" : "Filtros"}{" "}
                <i
                  className={
                    verFiltros ? "fas fa-chevron-up" : "fas fa-chevron-down"
                  }
                ></i>
                {filtrosActivos ? ` (${filtrosActivos})` : ""}
              </Button>
            </div>

            <div className="col-md-3 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
            <div className="col-md-1 flex-row-reverse">
              <Button
                size="sm"
                className="btn"
                color="info"
                onClick={limpiarSearch}
              >
                Limpiar
              </Button>
            </div>
          </div>

          <Collapse isOpen={verFiltros}>
            <div
              style={{
                border: "1px solid #e2e8f0",
                borderRadius: 8,
                padding: "8px 14px",
                margin: "6px 0",
              }}
            >
              <Row>
                <Col md={6}>
                  <Label className="negrita">LINEA</Label>
                  <div style={{ maxHeight: 190, overflowY: "auto" }}>
                    {lineas
                      .sort((a, b) => (a.linea > b.linea ? 1 : -1))
                      .map((a) => (
                        <div key={a.idLinea}>
                          <label style={{ marginBottom: 0 }}>
                            <Switch
                              size="small"
                              value={a.idLinea}
                              checked={selectedLineaFiltro.includes(a.idLinea)}
                              onChange={handleCheckboxChangeLinea}
                              color="primary"
                            />
                            {a.linea}
                          </label>
                        </div>
                      ))}
                  </div>
                </Col>
                <Col md={6}>
                  <Label className="negrita">EMPRESA</Label>
                  <div style={{ maxHeight: 190, overflowY: "auto" }}>
                    {empresas
                      .sort((a, b) => (a.empresa > b.empresa ? 1 : -1))
                      .map((a) => (
                        <div key={a.idEmpresa}>
                          <label style={{ marginBottom: 0 }}>
                            <Switch
                              size="small"
                              value={a.idEmpresa}
                              checked={selectedEmpresaFiltro.includes(
                                a.idEmpresa
                              )}
                              onChange={handleCheckboxChangeEmpresa}
                              color="primary"
                            />
                            {a.empresa}
                          </label>
                        </div>
                      ))}
                  </div>
                </Col>
              </Row>
            </div>
          </Collapse>
          <br />

          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((a) => (
                <tr key={a._id}>
                  <td>{a.fecha}</td>
                  <td>{a.compra}</td>
                  <td>{a.SKU}</td>
                  <td>{a.nombre}</td>
                  <td>{a.linea}</td>
                  <td>{a.empresa}</td>
                  <td>{a.area}</td>
                  <td>{numero(a.cantidad)}</td>
                  <td>{dinero(a.costoMX)}</td>
                  <td>{dinero(a.total)}</td>
                </tr>
              ))}
              {!commentsData.length ? (
                <tr>
                  <td colSpan="10" style={{ color: "#94a3b8" }}>
                    Sin compras en el periodo.
                  </td>
                </tr>
              ) : null}
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita">TOTAL</td>
                <td className="negrita">{numero(totales.cantidad)}</td>
                <td></td>
                <td className="negrita">{dinero(totales.total)}</td>
              </tr>
            </tbody>
          </Table>
          <Pagination
            total={totalItems}
            itemsPerPage={ITEMS_PER_PAGE}
            currentPage={currentPage}
            onPageChange={(page) => setCurrentPage(page)}
          />
        </div>
      ) : undefined}
      {loader}
    </>
  );
}

export default ReporteCompras;
